import {isNil} from "../Helper";

export default function initResidentialMarketItemFilter() {

  const filterElement = document.getElementById('residentialmarket-filter');
  if(isNil(filterElement)) {
    // no filter element has been found
    return;
  }

  const filterRooms = document.getElementById('filter-rooms');
  const filterFloor = document.getElementById('filter-floor');
  const filterStreet = document.getElementById('filter-street');
  const filterStatus = document.getElementById('filter-status');
  const resetFilters = document.getElementById('reset-filters');
  const sortColumn = document.getElementById('sort-column');
  const sortOrder = document.getElementById('sort-order');
  const table = document.querySelector('.table tbody');
  const floorLabels = {
    "-1": "1. GG",
    "-2": "2. GG",
    "0": "EG",
    "1": "1. OG",
    "2": "2. OG",
    "3": "3. OG",
    "4": "4. OG",
    "5": "5. OG",
    "6": "6. OG",
    "7": "7. OG",
    "99": "Attika"
  };
  if(!isNil(table)) {
    const optionAll = document.createElement('option');
    optionAll.value = '';
    optionAll.textContent = 'alle';

    // set room options based on present apartments
    const uniqueRooms = new Set(Array.from(table.rows).map(row => row.dataset.rooms).sort((a, b) => a - b));
    if (uniqueRooms.size > 0) {
      filterRooms.innerHTML = ''; // Remove all existing options
      if (uniqueRooms.size > 1) {
        filterRooms.appendChild(optionAll.cloneNode(true));
      }
      uniqueRooms.forEach(room => {
        const option = document.createElement('option');
        option.value = room;
        option.textContent = room;
        filterRooms.appendChild(option);
      });
    }

    // set floor options based on present apartments
    const uniqueFloors = new Set(Array.from(table.rows).map(row => row.dataset.floor).sort((a, b) => a - b));
    if (uniqueFloors.size > 0) {
      filterFloor.innerHTML = ''; // Remove all existing options
      if (uniqueFloors.size > 1) {
        filterFloor.appendChild(optionAll.cloneNode(true));
      }
      uniqueFloors.forEach(floor => {
        const option = document.createElement('option');
        option.value = floor;
        option.textContent = floorLabels[floor];
        filterFloor.appendChild(option);
      });
    }

    // set street options based on present apartments
    const uniqueStreets = new Set(Array.from(table.rows).map(row => row.dataset.street).sort((a, b) => a - b));
    if (uniqueStreets.size > 0) {
      filterStreet.innerHTML = ''; // Remove all existing options
      if (uniqueStreets.size > 1) {
        filterStreet.appendChild(optionAll); // .cloneNode(true) not needed on last usage
      }
      else {
        // hide street filter if only one street is present
        filterStreet.parentElement.style.display = 'none';
      }
      uniqueStreets.forEach(street => {
        const option = document.createElement('option');
        option.value = street;
        option.textContent = street;
        filterStreet.appendChild(option);
      });
    }
  }



  resetFilters.style.display = 'none'

  function filterTable() {

    if (table.rows.length === 0) { return }
    const rooms = filterRooms.value;
    const floor = filterFloor.value;
    const street = filterStreet.value;
    const status = filterStatus.value;

    Array.from(table.rows).forEach(row => {
      const roomMatch = !rooms || row.dataset.rooms === rooms;
      const floorMatch = !floor || row.dataset.floor === floor;
      const streetMatch = !street || row.dataset.street === street;
      const statusMatch = !status || row.dataset.status === status;

      if (roomMatch && floorMatch && streetMatch && statusMatch) {
        row.style.display = '';
      } else {
        row.style.display = 'none';
      }
    });

    const countVisibleRows = Array.from(table.rows).filter(row => row.style.display !== 'none').length;
    const nowEntriesInfo = table.querySelector('#no-matches-info');
    if (nowEntriesInfo) {
      // remove no entries row
      nowEntriesInfo.remove();
    }

    if (countVisibleRows === 0) {
      const noEntriesRow = document.createElement('tr');
      noEntriesRow.id = 'no-matches-info';
      noEntriesRow.innerHTML = `
    <td colspan="9" class="text-center bg-secondary">
      Leider passt keine Wohnung zum gewählten Filter. <a href="#" class="reset-residentialmarket-filters">Filter zurücksetzen</a>
    </td>
  `;
      table.appendChild(noEntriesRow);
      // add close event to row
      noEntriesRow.addEventListener('click', (event) => {
        event.preventDefault();
        resetTableFilters();
      });
    }

    if (countVisibleRows === table.rows.length) {
      resetFilters.style.display = 'none'
    }
    else {
      resetFilters.style.display = ''
    }
  }

  function resetTableFilters() {
    filterRooms.value = '';
    filterFloor.value = '';
    filterStreet.value = '';
    filterStatus.value = '';
    resetFilters.style.display = ''

    filterTable();
  }

  function sortTable() {
    const column = sortColumn.value || 'rooms';
    const order = sortOrder.value || 'asc';
    const rows = Array.from(table.rows);

    const columnIndex = {
      rooms: 0,
      floor: 1,
      street: 3,
      status: 9
    }[column];

    rows.sort((a, b) => {

      if(a.dataset[column] === undefined) {
        console.log(`Column ${column} not found in dataset`);
        return 0;
      }

      const aValue = a.dataset[column];
      const bValue = b.dataset[column];

      if (order === 'asc') {
        return aValue.localeCompare(bValue, undefined, { numeric: true });
      } else {
        return bValue.localeCompare(aValue, undefined, { numeric: true });
      }
    });

    rows.forEach(row => table.appendChild(row));
  }

  filterRooms.addEventListener('change', filterTable);
  filterFloor.addEventListener('change', filterTable);
  filterStreet.addEventListener('change', filterTable);
  filterStatus.addEventListener('change', filterTable);
  resetFilters.addEventListener('click', resetTableFilters);

  sortColumn.addEventListener('change', sortTable);
  sortOrder.addEventListener('change', sortTable);

  // trigger initial sort
  sortTable();

}
